import { StrictMode } from 'react';

import { isDev } from '@legacy/utils/env';
import { createRoot } from 'react-dom/client';
import '@legacy/assets/styles/globals.scss';

import '@styles/main.scss';

import { App } from './App.tsx';
import { config } from '@/config';
import '@legacy/services/datadogLogs';
import '@legacy/services/realUserMonitoring';
import 'material-symbols/rounded.css'; // reduce build size by only importing rounded icons

// Setup MSW only when needed in development
if (isDev && (config.bypassTLP || config.enableMock)) {
  const { worker } = await import('@legacy/mocks/browser');

  if (config.bypassTLP) {
    await worker.start({ onUnhandledRequest: 'bypass' });
  } else if (config.enableMock) {
    await worker.start({
      onUnhandledRequest: 'bypass',
      findWorker: (scriptURL) => scriptURL.includes('mockServiceWorker'),
    });
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
